module.exports = __webpack_public_path__ + "static/media/logo_EMPRESA.5830b416.svg";